export const CREATE_MOVIE = 'MOVIE/CREATE';
export const LOAD_MOVIES = 'MOVIES/LOAD';
export const DELETE_MOVIE = 'MOVIE/DELETE';
export const LOADING_STATUS = 'MOVIE/LOADING_STATUS';
